import { RecordType } from '@xbcb/shared-types';
import {
  workOrderTaskFragments,
  workOrderTaskStepFragments,
} from '@xbcb/work-order-queries';
import { UsIorActivation } from '../../loadableComponents';
import { WorkOrderRoute } from '.';
import {
  appRecordAbiDataMenuItem,
  appRecordAssignWorkOrderTaskMenuItem,
  createQueryUsIorKebabMenuItem,
  createUsIorCreate5106KebabMenuItem,
  createUsIorRequestCbpAssignedNumberKebabMenuItem,
  createUsIorUpdate5106KebabMenuItem,
  inquireWorkOrderItem,
  unblockWorkOrderItem,
} from '../utils';
import { usIorActivationFragments } from 'libs/sharedQueries';
import { appRecordSendAbiMessage } from '../utils/appRecordSendAbiMessage';
import { createUsIorActivateButton } from './shared/usIorActivationUtils';

const fields = `
  ...usIorActivationFields
  tasks {
    ...workOrderTaskFields
    assignee {
      id
      name
    }
    steps {
      id
      name
      description
      completed {
        time
      }
      isCompletedBySystem
      isFinalConfirmation
    }
    definition {
      id
      workOrderTaskType
    }
  }
`;

const pathToUsIor = ['ior', 'usIor'];
const usIorActivationRoute: WorkOrderRoute = {
  Page: UsIorActivation,
  recordType: RecordType.US_IOR_ACTIVATION,
  fields,
  fragments: `${usIorActivationFragments}${workOrderTaskFragments}${workOrderTaskStepFragments}`,
  kebabMenuItems: [
    appRecordAbiDataMenuItem,
    appRecordSendAbiMessage,
    appRecordAssignWorkOrderTaskMenuItem,
    inquireWorkOrderItem,
    unblockWorkOrderItem,
    createQueryUsIorKebabMenuItem(pathToUsIor),
    createUsIorCreate5106KebabMenuItem(pathToUsIor),
    createUsIorUpdate5106KebabMenuItem(pathToUsIor),
    createUsIorRequestCbpAssignedNumberKebabMenuItem(pathToUsIor),
  ],
  submitButtons: [createUsIorActivateButton(pathToUsIor)],
};

export default usIorActivationRoute;
